import React from 'react';

export const InputField = ({
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder = '',
  disabled = false,
  className = '',
  maxLength,
  pattern,
}) => {
  return (
    <label>
      {label}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        maxLength={maxLength}
        pattern={pattern}
      />
    </label>
  );
};
